export default __webpack_public_path__ + "static/class-hand-5a110633f5d7016ad98838d53cbdf3ba.jpg";